import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import logo from "../assets/images/logo.png";
// import line from "../assets/images/yellow-line.png";

import { IoClose } from "react-icons/io5";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const links = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "about" },
  { name: "Why Choose Us", path: "whyChooseUs" },
  { name: "Screenshots", path: "screenshots" },
  { name: "Download App", path: "downloadApp" },
  { name: "Contact Us", path: "contact" },
];

export default function Navbar() {
  const [activeLink, setActiveLink] = useState("/");

  return (
    <>
      <nav
        className="container navbar navbar-expand-lg bg-transparent px-3"
        style={{ height: "100px" }}
      >
        <Link
          className="navbar-brand d-flex align-items-center flex-column gap-2"
          to="/"
          style={{ textDecoration: "none" }}
        >
          <img src={logo} alt="Logo" className="logo" />
          <span className="inter-font brand-text" style={{ fontSize: "10px" }}>
            Global Arabian Trading Bank
          </span>
        </Link>

        <button
          className="navbar-toggler d-lg-none"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse d-none d-lg-flex">
          <ul className="navbar-nav ms-auto gap-4">
            {links.map((l) => (
              <li
                className="nav-item d-flex flex-column align-items-center"
                key={l.path}
              >
                <Link
                  to={`/#${l.path}`}
                  className={`nav-link mt-2 ${
                    activeLink === l.path ? "active" : ""
                  }`}
                  onClick={() => setActiveLink(l.path)}
                >
                  {l.name}
                </Link>
                {/* {activeLink === l.path && (
                  <img src={line} alt="" className="nav-underline" />
                )} */}
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <div
        className="offcanvas offcanvas-start d-lg-none"
        id="offcanvasNavbar"
        tabIndex="-1"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title mb-0">
            <img src={logo} alt="Logo" className="logo" />
          </h5>
          <button
            type="button"
            className="border-0 bg-transparent fs-3 text-white close-btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <IoClose />
          </button>
        </div>

        <div className="offcanvas-body">
          <ul className="navbar-nav gap-3">
            {links.map((l) => (
              <li
                className="nav-item d-flex flex-column align-items-start"
                key={l.path}
              >
                <ScrollLink
                  style={{ fontSize: "1.125rem" }}
                  to={l.path}
                  smooth
                  duration={200}
                  spy
                  className={`nav-link ${
                    activeLink === l.path ? "active" : ""
                  }`}
                  onClick={() => setActiveLink(l.path)}
                  data-bs-dismiss="offcanvas"
                >
                  {l.name}
                </ScrollLink>
                {/* {activeLink === l.path && (
                  <img src={line} alt="" className="nav-underline" />
                )} */}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
